export default function getTimestamp(time) {
  return Date.parse(time);
}
